module.exports = __webpack_public_path__ + "static/media/solution-tube-k-full-open.384cd074.svg";